import React from 'react';
import CybsButton from '@cybs-ui/components/lib/button';
import {connect} from 'react-redux';
import {loadUrlInNewTab} from '../../../../../libs/common-library';
import '../css/header.css';

// This is a button component which contains see overview link
class SeeOverview extends React.Component{
  render(){
    if(this.props.seeOverViewLink != undefined){
    return(
      <div class ="seeOverview" id = "seeOverview">
                            <CybsButton
                                dataTest="secondaryButton"
                                i18n={{ label: 'See Product Overview' }}
                                onClick={() => loadUrlInNewTab(this.props.seeOverViewLink)}
                                colorScheme="secondary"
                                className = "border_color_theme_primary"
                            />
      </div>
    )  
    }
    else{
      return (<div></div>)
    }
  }
}


// fetching data from data store.
function mapStateToProps(state){
  return{
    seeOverViewLink: state.rhsReducer.seeOverViewLink
  }
}

export default connect(mapStateToProps)(SeeOverview);
